module.exports = __webpack_public_path__ + "static/img/head_bg_2.765f2da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival-tw/head/head_bg_2.png
// module id = qeZW
// module chunks = 1 9